interface GameOverScreenProps {
  score: number;
  hasGun: boolean;
  hasAxe: boolean;
  hasLaser: boolean;
  hasGrenade: boolean;
  onPlayAgain: () => void;
  onMainMenu: () => void;
}

const GameOverScreen = ({ score, hasGun, hasAxe, hasLaser, hasGrenade, onPlayAgain, onMainMenu }: GameOverScreenProps) => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center">
      <h2 className="text-4xl font-bold text-red-500 mb-4">GAME OVER</h2>
      <p className="text-2xl mb-2">Your score: {score}</p>
      {hasGun && <p className="text-lg text-yellow-300 mb-2">You unlocked the gun! 🔫</p>}
      {hasAxe && <p className="text-lg text-orange-300 mb-2">You unlocked the axe! 🪓</p>}
      {hasLaser && <p className="text-lg text-red-300 mb-2">You unlocked the laser! 🔴</p>}
      {hasGrenade && <p className="text-lg text-orange-500 mb-4">You unlocked the grenade launcher! 💣</p>}
      <div className="flex gap-4">
        <button
          onClick={onPlayAgain}
          className="px-6 py-3 bg-purple-700 hover:bg-purple-600 rounded-lg font-bold transition-colors">
          PLAY AGAIN
        </button>
        <button
          onClick={onMainMenu}
          className="px-6 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg font-bold transition-colors">
          MAIN MENU
        </button>
      </div>
    </div>
  );
};

export default GameOverScreen;
